(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["partner-banner"]) return;
  try {
    
(function() {
  const PARTNERS = {
    harlig: {
      code: 'HARLIG',
      name: 'Harli G'
    },
    morgandrinkscoffee: {
      code: 'MDC',
      name: 'MorganDrinksCoffee'
    },
    mindyminx: {
      code: 'MINX',
      name: 'Mindy Minx'
    },
    saucestache: {
      code: 'SAUCESTACHE',
      name: 'Sauce Stache'
    },
    cambriajoy: {
      code: 'CAMBRIAJ',
      name: 'Cambria Joy'
    },
    chrissstttiiinnne: {
      code: 'CHRISTINE',
      name: 'chrissstttiiinnne'
    },
    captainsinbad: {
      code: 'SINBAD',
      name: 'Captain Sinbad'
    },
    thevegancyclist: {
      code: 'VEGANCYCLIST',
      name: 'The Vegan Cyclist',
    }
  };

  const query = window.location.search;
  const hasPartnerParams = query.indexOf('?') === 0
    && query.includes('utm_medium=')
    && query.includes('utm_campaign=');

  if (hasPartnerParams) {
    const params = getParams(query);
    const partner = PARTNERS[params.utm_campaign];

    if (params.utm_medium === 'influencer' && partner != null) {
      const $banner = document.getElementById('partner-banner');
      const $bannerText = document.querySelector('#partner-banner .page-width');
      $bannerText.innerText = `👋 Welcome ${partner.name} fans! Get 15% off with code ${partner.code}!`
      $banner.style.display = 'block';
    }
  }

  function getParams(query) {
    const kvStrings = query.slice(1).split('&'); // yadda=x
    const params = kvStrings.reduce((acc, el) => {
      const pair = el.split('=');
      return Object.assign({}, acc, { [pair[0]]: pair[1] });
    }, {});
    return params;
  }
})();

  } catch(e) { console.error(e); }
})();

})();
